import ReactDOM from 'react-dom'
import { useCallback, useState } from 'react'
import { useOnCreate, useOnDestroy } from 'utils/customHooks/useLifeCycleHooksAndRouter'
import ImagePreviewOverlay from './components/ImagePreviewOverlay'
import { ImagePreviewEventType } from './@types'
import { CUSTOM_EVENT_CLOSE_IMAGE_PREVIEW, CUSTOM_EVENT_OPEN_IMAGE_PREVIEW } from './constant'
import { closeImagePreview } from './utils'

const ImagePreviewContainer = ({ className = '' }: { className?: string }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [images, setImages] = useState<string[]>([])
  const [thumbnails, setThumbnails] = useState<string[]>([])
  const [currentIndex, setCurrentIndex] = useState(0)

  useOnCreate(() => {
    window.addEventListener(CUSTOM_EVENT_OPEN_IMAGE_PREVIEW, handleOpen as EventListener)
    window.addEventListener(CUSTOM_EVENT_CLOSE_IMAGE_PREVIEW, handleClose)
  }, [])

  useOnDestroy(() => {
    window.removeEventListener(CUSTOM_EVENT_OPEN_IMAGE_PREVIEW, handleOpen as EventListener)
    window.removeEventListener(CUSTOM_EVENT_CLOSE_IMAGE_PREVIEW, handleClose)
  }, [])

  const handleOpen = (e: CustomEvent<ImagePreviewEventType>) => {
    setImages(e.detail.images)
    setCurrentIndex(e.detail.index ?? 0)
    setThumbnails(e.detail.thumbnails || [])
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
    setImages([])
    setCurrentIndex(0)
    setThumbnails([])
  }

  const handleSetCurrentIndex = useCallback((index: number) => {
    setCurrentIndex(index)
  }, [])

  const handleCloseImagePreview = useCallback(() => {
    closeImagePreview()
  }, [])

  if (!isOpen) return null

  if (!document) return null

  return ReactDOM.createPortal(
    <ImagePreviewOverlay
      className={className}
      images={images}
      thumbnails={thumbnails}
      currentIndex={currentIndex}
      onClose={handleCloseImagePreview}
      onSetCurrentIndex={handleSetCurrentIndex}
    />,
    document.body,
  )
}

export default ImagePreviewContainer
